import styled from 'styled-components';

interface GameSegmentSearchOptionsProps {
  $withoutMargin?: boolean;
}
const StyledInvalidField = styled.div`
  color: ${(props) => props.theme.colors.danger};
  margin-top: 3px;
`;
const GameSegmentSearchOptions = styled.div<GameSegmentSearchOptionsProps>`
  max-width: 34rem;
  margin-top: ${(props) => (props.$withoutMargin ? '0' : '1.9rem')};
  margin-bottom: 1.71rem;

  .ant-input-group > .ant-input {
    border-radius: ${(props) => `0 ${props.theme.customBorderRadius.borderRadiusDefault} ${props.theme.customBorderRadius.borderRadiusDefault} 0`};
  }

  > span {
    margin: 1.86rem 0 0.57rem;
    display: inline-block;
    font-size: ${(props) => props.theme.typography.fontSizeDefault};
  }
`;

export { StyledInvalidField, GameSegmentSearchOptions };
